import axios from 'axios';
import { message } from 'antd';
import Cookies from "js-cookie";
 
const API_BASE_URL = 'https://aiterp-api-dev-ws-as.azurewebsites.net/';
 
class APICall {
  constructor(token) {
    // this.TOKEN = Cookies.get("auth_token");
    // this.AzureId = Cookies.get("azure_id");
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers:{
        "Accept": "application/json",
        // "Authorization": `Bearer ${this.TOKEN}`,
        //  "Token": `9c1a15a3-0659-41a1-b6d6-de17f7cd3fb6`,
        // 'X-Azure-Id':this.AzureId
        }
    });
  }
  async showSuccessMessage(msg) {
    message.success("Room joined successfully");
  }
 
  // async showErrorMessage(msg) {
  //   message.error(msg, 3);
  // }
 
  async globalAPICAll(endPoint, method = "get", payload = {}) {
    try {
        let response;
        if (method === "get") {
          response = await this.api.get(endPoint);
        } else if (method === "post") {
          response = await this.api.post(endPoint, payload);
        } else if (method === "delete") {
          response = await this.api.delete(endPoint);
        } else if (method === "patch") {
          response = await this.api.patch(endPoint, payload);
        } else if (method === "put") {
          response = await this.api.put(endPoint, payload);
        }
        const data = response.data
        if( method !== 'get' ){
          message.success("Room joined successfully");
        }
        return data
    } catch (error) {
     
        try {
          if (error.response) {
            this.showErrorMessage(error.response.data.detail);
            // return error.status
          }
        } catch (error) {
          this.showErrorMessage("Error fetching data");
          // return error.status
      }
    }
  }
 
  async validateSessionId(sessionId) {
    const endpoint = `/sessions/validate_session/${sessionId}`;
    return this.globalAPICAll(endpoint, "get");
  }
 
  async postAttedendee(payload) {
    const endpoint = `/attendees/`;
    return this.globalAPICAll(endpoint, "post", payload);
  }
}
 
export default APICall;
 
 